"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost = void 0;
var BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost_1 = require("./BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost");
Object.defineProperty(exports, "BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost", { enumerable: true, get: function () { return BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost_1.BodySubmitABatchCallRequestV1ConvaiBatchCallingSubmitPost; } });
